module.exports = __webpack_public_path__ + "static/media/lady-carrying-water.691ac455.png";